import React from 'react';
import { ShieldCheck, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Shown when the magic link is opened again after all documents were
// submitted: the token is disabled server-side, so no guest data is
// available — only a clear "already used" notice.
const LinkUsedView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen page-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-dashboard border border-slate-200 overflow-hidden">

        {/* Amber top bar */}
        <div className="h-1.5 bg-gradient-to-r from-amber-400 to-amber-600" />

        <div className="p-8 space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-amber-50 border border-amber-100 flex items-center justify-center">
              <ShieldCheck className="h-10 w-10 text-amber-500" />
            </div>
          </div>

          {/* Text */}
          <div className="text-center space-y-2">
            <h2 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{t('linkUsed.title')}</h2>
            <p className="text-slate-500 leading-relaxed">
              {t('linkUsed.message')}
            </p>
          </div>

          <div className="flex items-center gap-3 px-4 py-3 bg-emerald-50 border border-emerald-100 rounded-xl text-sm text-emerald-700">
            <CheckCircle className="h-5 w-5 shrink-0 text-emerald-500" />
            <span>{t('linkUsed.documentsReceived')}</span>
          </div>

          <p className="text-center text-xs text-slate-500">
            {t('linkUsed.contactHost')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LinkUsedView;
